"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cLoadingState = exports.singleMetricStatistics = exports.hardCodedStatistics = exports.customisableStatistics = exports.availableStats = void 0;
// List of all the available types of statistics that can be
// picked when creating a report.
exports.availableStats = Object.freeze({
    users: 'users',
    acceptedRegistrationsAuto: 'acceptedRegistrationsAuto',
    acceptedRegistrationsManual: 'acceptedRegistrationsManual',
    acceptedRegistrationsInvitation: 'acceptedRegistrationsInvitation',
    acceptedRegistrationsApi: 'acceptedRegistrationsApi',
    appliedRegistrations: 'appliedRegistrations',
    rejectedRegistrations: 'rejectedRegistrations',
    inProgressRegistrations: 'inProgressRegistrations',
    canceledRegistrations: 'canceledRegistrations',
    suspendedRegistrations: 'suspendedRegistrations',
    logins: 'logins',
    userProfileEdits: 'userProfileEdits',
    chatMessages: 'chatMessages',
    entityInSearchResults: 'entityInSearchResults',
    entityViews: 'entityViews',
    entityClicks: 'entityClicks',
    pageViews: 'pageViews',
    userSearches: 'userSearches',
    userProfilePageViews: 'userProfilePageViews',
    entitySearch: 'entitySearch',
    profileSearch: 'profileSearch',
    searchFilters: 'searchFilters',
    // sessions: 'sessions',
    connectionsCreated: 'connectionsCreated',
    applicationsOverTime: 'applicationsOverTime',
    currentApplications: 'currentApplications',
    posts: 'posts',
    comments: 'comments',
    reportedPosts: 'reportedPosts',
    // favouritedEntities: 'favouritedEntities',
    activityFeed: 'activityFeed',
    chatMessageRead: 'chatMessageRead',
    externalLinkClicks: 'externalLinkClicks',
    modalsOpened: 'modalsOpened',
    videoChatCallMade: 'videoChatCallMade',
    videoChatCallAccepted: 'videoChatCallAccepted',
    videoChatCallRejected: 'videoChatCallRejected',
    iframeLoaded: 'iframeLoaded',
    externalInteractions_attendedExclWalkIns: 'externalInteractions_attendedExclWalkIns',
    externalInteractions_attendedWalkIn: 'externalInteractions_attendedWalkIn',
    // externalInteractions_noShow: 'externalInteractions_noShow',
    externalInteractions_RSVPedAccepted: 'externalInteractions_RSVPedAccepted',
    externalInteractions_RSVPedDeclined: 'externalInteractions_RSVPedDeclined',
    externalInteractions_RSVPedTentative: 'externalInteractions_RSVPedTentative',
    externalInteractions_invited: 'externalInteractions_invited',
    externalInteractions_attendedToInvitedRatio: 'externalInteractions_attendedToInvitedRatio',
    externalInteractions_rsvpToInvitedRatio: 'externalInteractions_rsvpToInvitedRatio',
});
// These give users all the customising options.
exports.customisableStatistics = [
    exports.availableStats.acceptedRegistrationsAuto,
    exports.availableStats.acceptedRegistrationsManual,
    exports.availableStats.acceptedRegistrationsInvitation,
    exports.availableStats.acceptedRegistrationsApi,
    exports.availableStats.appliedRegistrations,
    exports.availableStats.rejectedRegistrations,
    exports.availableStats.canceledRegistrations,
    exports.availableStats.suspendedRegistrations,
    exports.availableStats.inProgressRegistrations,
    exports.availableStats.logins,
    exports.availableStats.userProfileEdits,
    exports.availableStats.entityInSearchResults,
    exports.availableStats.entityViews,
    exports.availableStats.entityClicks,
    exports.availableStats.userSearches,
    exports.availableStats.entitySearch,
    exports.availableStats.profileSearch,
    exports.availableStats.searchFilters,
    // availableStats.sessions,
    exports.availableStats.connectionsCreated,
    exports.availableStats.applicationsOverTime,
    exports.availableStats.posts,
    exports.availableStats.comments,
    exports.availableStats.currentApplications,
    exports.availableStats.reportedPosts,
    exports.availableStats.userProfilePageViews,
    // availableStats.favouritedEntities,
    exports.availableStats.pageViews,
    exports.availableStats.chatMessages,
    exports.availableStats.chatMessageRead,
    exports.availableStats.externalLinkClicks,
    exports.availableStats.modalsOpened,
    exports.availableStats.videoChatCallAccepted,
    exports.availableStats.videoChatCallMade,
    exports.availableStats.videoChatCallRejected,
    exports.availableStats.iframeLoaded,
    // availableStats.externalInteractions_noShow,
    exports.availableStats.externalInteractions_attendedExclWalkIns,
    exports.availableStats.externalInteractions_attendedWalkIn,
    exports.availableStats.externalInteractions_RSVPedAccepted,
    exports.availableStats.externalInteractions_RSVPedDeclined,
    exports.availableStats.externalInteractions_RSVPedTentative,
    exports.availableStats.externalInteractions_invited,
    exports.availableStats.externalInteractions_attendedToInvitedRatio,
    exports.availableStats.externalInteractions_rsvpToInvitedRatio,
];
// These do not allow users to make any modifications.
exports.hardCodedStatistics = [exports.availableStats.activityFeed];
/**
 * Still working out how it fits with the rest,
 * but the idea is that this is just a snapshot
 * of the current state of the system.
 */
exports.singleMetricStatistics = [exports.availableStats.users];
exports.cLoadingState = {
    idle: 'idle',
    loading: 'loading',
    loaded: 'loaded'
};
